import { Controller } from "@hotwired/stimulus";
import { getLocaleData, getLocaleIso } from "../lib/tel-input-locale";
import intlTelInput from "intl-tel-input";
import utils from "intl-tel-input/utils";

// Connects to data-controller="tel-input"
export default class extends Controller {
  static values = {
    locale: String,
  };

  connect() {
    const input = this.element.querySelector("input[type='tel']");

    intlTelInput(input, {
      uiTranslations: getLocaleData(this.localeValue),
      countryNameLocale: getLocaleIso(this.localeValue),
      loadUtils: async () => ({ default: utils }),
      hiddenInputs: (telInputName) => ({ phone: telInputName }),
      initialCountry: "ch",
    });
  }
}
